import { Component, ViewContainerRef } from '@angular/core';
import { Store } from '@ngrx/store';

import { NinetyMobileBannerService } from '@ninety/platform/components';
import { DatadogRumUserSyncService } from '@ninety/platform/services/services/datadog-rum-sync.service';
import { SpinnerService, appActions } from '@ninety/platform/state';
import { selectCompanyColorBranding } from '@ninety/platform/state/app-global/company/company-state.selectors';
import { OpenTabsMetricService } from '@ninety/ui/legacy/core/vendor/opentelemetry/metrics/open-tabs.service';

// BACKWARD COMPAT (DEV-25315): These plugin imports remain here to support
// NinetyTextEditorFroalaComponent and LearningFroalaEditorComponent, which rely
// on plugins being registered globally before their editors initialize.
// NinetyRichTextEditorComponent has its own froala-plugins.ts barrel that will
// become the canonical home once legacy components are migrated.
// TODO: Remove these imports after legacy Froala components are migrated.
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/emoticons.min.js';
import 'froala-editor/js/plugins/file.min.js';
import 'froala-editor/js/plugins/files_manager.min.js';
import 'froala-editor/js/plugins/font_family.min.js';
import 'froala-editor/js/plugins/font_size.min.js';
import 'froala-editor/js/plugins/image.min.js';
import 'froala-editor/js/plugins/inline_class.min.js';
import 'froala-editor/js/plugins/inline_style.min.js';
import 'froala-editor/js/plugins/line_breaker.min';
import 'froala-editor/js/plugins/line_height.min';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/page_break.min.js';
import 'froala-editor/js/plugins/paragraph_format.min';
import 'froala-editor/js/plugins/paragraph_style.min';
import 'froala-editor/js/plugins/quote.min.js';
import 'froala-editor/js/plugins/table.min.js';
import 'froala-editor/js/plugins/url.min.js';
import 'froala-editor/js/plugins/video.min.js';
import 'froala-editor/js/plugins/word_paste.min.js';
import 'froala-editor/js/third_party/embedly.min.js';

/* eslint-disable @angular-eslint/prefer-standalone */
@Component({
  standalone: false,
  selector: 'ninety-root',
  template: `<router-outlet [ninetyTheme]="companyColorBranding$ | async"></router-outlet>`,
})
export class AppComponent {
  protected readonly companyColorBranding$ = this.store.select(selectCompanyColorBranding);

  constructor(
    private store: Store,
    public spinnerService: SpinnerService,
    private ninetyMobileBannerService: NinetyMobileBannerService,
    private viewContainerRef: ViewContainerRef,
    private _datadogRumUserSync: DatadogRumUserSyncService,
    private openTabsService: OpenTabsMetricService
  ) {
    this.store.dispatch(appActions.bootstrap());

    this.ninetyMobileBannerService.initialize(this.viewContainerRef);
  }
}
